import { Colors } from "@/constants/Colors"
import { ActivityIndicator, Text, View } from "react-native"
import { SafeAreaView } from "react-native-safe-area-context"

interface LoadingScreenProps {
  message?: string
}

export default function LoadingScreen({ message = "Loading EMO.coach..." }: LoadingScreenProps) {
  return (
    <SafeAreaView style={{ backgroundColor: Colors.dark.surface }} className="flex-1">
      <View className="flex-1 items-center justify-center">
        <ActivityIndicator size="large" color={Colors.dark.primary} />
        <Text className="text-white mt-4" style={{ color: Colors.dark.textPrimary }}>
          {message}
        </Text>
      </View>
    </SafeAreaView>
  )
}
